<template>
  <a-row :gutter="8" :class="getScreen ? 'm-list-wrapper' : 'd-list-wrapper'">
    <a-col :xs="{ span: 24 }" :lg="{ span: 8 }">
      <a-card :loading="loading">
        <div slot="title"><a-icon type="file-search" />&nbsp; Search</div>
        <ul class="m-list-wrapper">
          <li>
            <a-input-search v-model="quickSearch" placeholder="Quick Search" />
          </li>
          <li>
            <a-collapse activeKey="0">
              <a-collapse-panel key="0">
                <span slot="header">Search More...</span>
                <div class="m-form-item-wrapper">
                  <label for="tanggalTransaksi">Transaction Date</label>
                  <a-date-picker
                    placeholder="Select Date"
                    v-model="searchDate"
                    format="DD-MMM-YYYY"
                    allowClear
                  />
                </div>
              </a-collapse-panel>
            </a-collapse>
          </li>
        </ul>
      </a-card>
    </a-col>
    <a-col :xs="{ span: 24 }" :lg="{ span: 16 }">
      <DataListSlot
        title="Sales Contract List"
        createLink="createSalesContract"
        :manifestLink="manifestSalesContract"
        editLink="editSalesContract"
        :noAction="canCreate == true ? true : false"
        :dataList="datasource"
      >
        <a-button-group
          slot="actions"
          v-if="item.source.cancelStatus !== 'Canceled'"
          slot-scope="item"
        >
          <template
            v-if="canCreate == true && item.source.tlc_create == getAuth.username && item.source.edit_sts=='1'"
          >
            <a-button icon="edit" @click="handleRevise(item.source)"
              >Revisi</a-button
            >
            <a-button @click="handleAmandemen(item.source)">Amandemen</a-button>
          </template>
        </a-button-group>
      </DataListSlot>
    </a-col>
  </a-row>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import CurrencyFormat from "@/mixins/CurrencyFormat";
import moment from "moment";

export default {
  name: "SalesContract",
  mixins: [CurrencyFormat],
  data() {
    return {
      loading: true,
      rawData: [],
      searchDate: null,
      quickSearch: "",
      canCreate: false,
    };
  },
  computed: {
    ...mapGetters([
      "getScreen",
      "getAuth",
      "getDefaultDateFormat",
      "getStandartFormatDate",
      "getDetailProduct",
      "getDetailInvoice",
      "getDocument",
    ]),
    datasource() {
      let outputData = this.rawData;

      if (this.quickSearch) {
        outputData = _.filter(
          outputData,
          (obj) =>
            obj.quickSearch &&
            obj.quickSearch
              .toLowerCase()
              .indexOf(this.quickSearch.toLowerCase()) >= 0
        );
      }

      if (this.searchDate) {
        let filter = moment(this.searchDate).format(this.getDefaultDateFormat);
        outputData = _.filter(outputData, (obj) => obj.subdesc[2] == filter);
      }

      return outputData;
    },
    manifestSalesContract(){
      if(this.$route.path.includes("/financialControl")){
        return "manifestSalesContractFin"
      } else {
        return "manifestSalesContract"
      }
    }
  },
  mounted() {
    this.fetch();
    this.$store.dispatch("resetState");
  },
  methods: {
    moment,
    fetch() {
      let linkmnfs = localStorage.getItem("nvky");
      if (linkmnfs=="99"){ //direktur
        this.manifestSalesContract = "manifestSalesContractdir";
      }else if (linkmnfs=="15"){ //keuangan
        this.manifestSalesContract = "manifestSalesContractKeu";
      }else if (linkmnfs=="1511"){ //Akuntansi
        this.manifestSalesContract = "manifestSalesContract-acc";
      }
      
      this.$store
        .dispatch("getSalesContractList", { auth: this.getAuth })
        .then((res) => {
          this.canCreate = res.data.can_create;
          res.data.data.forEach((data) => {
            this.rawData.push({
              status: data.edit_sts == 1 ? "Revised" : "",
              status_besar: data.status_besar,
              edit_sts: data.edit_sts,
              title: data.no_sales_contract,
              subtitle: data.contract_no,
              subdesc: [
                data.kode,
                data.description,
                moment(data.tanggal).format(this.getDefaultDateFormat),
                this.formatCurrency(data.project_currency, data.project_value),
              ],
              //timeline: JSON.parse(data.workflow_status),
              id: data.id_sales_contract,
              closeStatus: data.close_sts == "1" ? "Close" : "",
              cancelStatus: data.cancel_sts
                ? data.cancel_sts == "1"
                  ? "Canceled"
                  : null
                : null,
              tlc_create: data.tlc_create,
              quickSearch:
                data.contract_no +
                " " +
                data.kode +
                " " +
                data.description +
                " " +
                data.no_sales_contract +
                " " +
                this.formatCurrency(data.project_currency, data.project_value),
            });
          });
          this.loading = false;
        });
    },
    handleRevise(item) {
      this.$router.push({
        name: "editSalesContractByType",
        params: { id: item.id, type: "revisi" },
      });
    },
    handleAmandemen(item) {
      this.$router.push({
        name: "editSalesContractByType",
        params: { id: item.id, type: "amandemen" },
      });
    },
  },
};
</script>

<style></style>
